import './Kontakt.css';
import BisCard from "../components/bisCard/BisCard";
import {Button} from "@radix-ui/themes";
import {useNavigate} from "react-router-dom";

function Kontakt() {

    const navigate = useNavigate();

    const onZurueckClick = () => {
        navigate('/');
    }

    const kontaktContent = (
        <div className="kontakt content-container-standard">
            <h1 className="kontakt-header">So erreichen Sie uns:</h1>
            <div className="kontakt-daten">
                <address>
                    <span className="anschrift-firma">Landesamt für Umwelt Rheinland-Pfalz</span><br/>
                    Kaiser-Friedrich-Straße 7<br/>
                    55116 Mainz<br/>
                </address>
                <div className="daten">
                    <p>
                        Telefon: 06131 60330<br/>
                        Fax: 06131 1432966<br/>
                        E-Mail: <a href="mailto:bis-bokat@lfu.rlp.de"
                                   aria-label="E-Mail an bis-bokat@lfu.rlp.de senden">bis-bokat@lfu.rlp.de</a>
                    </p>
                </div>
            </div>
            <Button id="btn-zurueck-anmeldung" onClick={onZurueckClick}>
                Zurück zur Anmeldung
            </Button>
        </div>
    );

    return (
        <div className="kontakt-container">
            <BisCard child={kontaktContent}/>
        </div>
    );
}

export default Kontakt;
